'use client'

export function Switch({
    checked,
    onChange,
    disabled = false,
}: {
    checked: boolean
    onChange: () => void
    disabled?: boolean
}) {
    return (
        <button
            type="button"
            aria-pressed={checked}
            aria-disabled={disabled}
            disabled={disabled}
            onClick={onChange}
            className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-accent/40 ${
                disabled ? 'opacity-50 cursor-not-allowed' : ''
            } ${checked ? 'bg-accent' : 'bg-gray-300'}`}
        >
            <span
                aria-hidden="true"
                className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition-transform duration-200 ease-in-out ${
                    checked ? 'translate-x-[18px]' : 'translate-x-0.5'
                }`}
            />
        </button>
    )
}
